/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TvScreen.vue?vue&type=template&id=faf4428e&scoped=true&"
import script from "./TvScreen.vue?vue&type=script&lang=js&"
export * from "./TvScreen.vue?vue&type=script&lang=js&"
import style0 from "./TvScreen.vue?vue&type=style&index=0&id=faf4428e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf4428e",
  null
  
)

export default component.exports